/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages

                $(document).ready(function(){
                  setTimeout(function(){
                    $('body').addClass('is-ready');
                  },1500);
                })

                $(".table-job").on('click', '.js-document-row > td', function () {
                  window.location = $(this).closest('tr').data('href');
                });


                if($('body').hasClass('home')){
                  $(document).on('scroll', function() {
                    if($(this).scrollTop()>=$('.js-btn-jobs-bottom').position().top + 300){
                      $('.js-btn-jobs-bottom').addClass('is-show');
                    }
                  })
                }

                var $loader = $('.js-loader');
                var $loginBox = $('.js-login-box');
                var $contactBox = $('.js-contact-box');
                var $lostPasswordBox = $('.js-lost-password-box');
                var $lostPasswordSuccess = $('.js-lost-password-success');
                var $formErrors = $('.js-form-error');
                $('.c-nav-services > a').on('click',function() { return false; });

                var login = function() {
                    $loader.fadeIn();
                    var email = $("#login-email").val();
                    var password = $("#login-password").val();

                    $.ajax({
                        type: 'POST',
                        url: ajaxurl, // check the exact URL for your situation
                        dataType: 'JSON',
                        data: ({ action: 'member_login', email: email, password: password }),
                        success: function(data) {
                            $formErrors.addClass('js-hide');

                            if (data.error) {

                                if (data.error === 'fields_not_filled') {
                                    $('.js-form-error-fields_not_filled').removeClass('js-hide');
                                }

                                if (data.error === 'not_registered') {
                                    $('.js-form-error-not_registered').removeClass('js-hide');
                                }

                                if (data.error === 'wrong_password') {
                                    $('.js-form-error-wrong_password').removeClass('js-hide');
                                }

                            }

                            if (data.success) {
                                Cookies.set('wordpress_test_ei', data.key, { path: '/' });
                                window.location.href = pageAccount;
                            } else {
                                $loader.fadeOut();
                            }

                        },
                        error: function(errorThrown) {
                            console.log("Error");
                            console.log(errorThrown);
                            $loader.fadeOut();
                            return false;
                        }

                    });
                };

                $('#js-login').submit(function(e){
                    e.preventDefault();
                    login();
                });


                $('.js-logout').click(function(e){
                    e.preventDefault();

                    $loader.fadeIn();
                    Cookies.remove('wordpress_test_ei', { path: '/' });
                    window.location.href = pageHome;
                });

                var isLoginOpen = false;
                var isContactOpen = false;
                var popupLogin = $('.js-popup-login');
                var popupContact = $('.js-popup-contact');

				var toggleLoginPopup = function(){
                    if (!isLoginOpen) {
                        $lostPasswordBox.hide();
                        $lostPasswordSuccess.hide();
                        $loginBox.show();
                        popupLogin.fadeIn();
                        isLoginOpen = true;
                    }else{
                        popupLogin.fadeOut();
                        isLoginOpen = false;
                    }
                };

				var toggleContactPopup = function(){
                    if (!isContactOpen) {
                        $contactBox.show();
                        popupContact.fadeIn();
                        isContactOpen = true;
                    }else{
                        popupContact.fadeOut();
                        isContactOpen = false;
                    }
                };


                $('.js-toggle-popup-login').click(function(e){
                    e.preventDefault();
                    $formErrors.addClass('js-hide');
                    $("#login-email").val('');
                    $("#login-password").val('');
                    toggleLoginPopup();
                });

                $('.js-toggle-popup-contact').click(function(e){
                    e.preventDefault();

                    toggleContactPopup();
                });


                $('.js-show-lost-password').click(function(e){
                    e.preventDefault();
                    $loginBox.fadeOut('fast', function() {
                        $formErrors.addClass('js-hide');
                        $("#lost-password-email").val('');
                        $lostPasswordBox.fadeIn('fast');
                    });
                });



                var sendLostPassword = function() {
                    $loader.fadeIn();
                    var email = $("#lost-password-email").val();
                    var $formErrors = $('.js-form-error');

                    $.ajax({
                        type: 'POST',
                        url: ajaxurl, // check the exact URL for your situation
                        dataType: 'JSON',
                        data: ({ action: 'member_recover_password', email: email }),
                        success: function(data) {

                            $formErrors.addClass('js-hide');

                            if (data.error) {

                                if (data.error === 'fields_not_filled') {
                                    $('.js-form-error-fields_not_filled').removeClass('js-hide');
                                }

                                if (data.error === 'not_registered') {
                                    $('.js-form-error-not_registered').removeClass('js-hide');
                                }

                            }

                            if (data.success) {
                                $lostPasswordBox.fadeOut('fast', function() {
                                    $lostPasswordSuccess.fadeIn('fast');
                                });
                            }

                            $loader.fadeOut();

                        },
                        error: function(errorThrown) {
                            console.log("Error");
                            console.log(errorThrown);
                            $loader.fadeOut();
                            return false;
                        }

                    });
                };

                $('#js-lost-password-form').submit(function(e){
                    e.preventDefault();
                    sendLostPassword();
                });

            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function() {
                // JavaScript to be fired on the home page

                var iamSelect = $('.js-iam-select');
                var iamSelectOptions = $(".js-iam-select-option");
                iamSelect.change(function() {
                    $val = iamSelect.val();

                    iamSelectOptions.css('display', 'none');
                    $(".js-iam-select-option[data-option='" + $val + "']").css('display', 'block');
                });

                // Popup home
                $(window).on('load', function(){
                    setTimeout(function(){
                        $('.js-popup-infos').addClass('active');
                    },200);
                });

                $('.js-close-popup').click(function() {
                    // $(this).parent().fadeOut(600);
                    $('.js-popup-infos').removeClass('active');
                });

            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'page_template_page_lost_password': {
            init: function() {
                // JavaScript to be fired on the about us page

                var $loader = $('.js-loader');
                var $changePasswordForm = $('#js-change-password-form');
                var $changePasswordSuccess = $('.js-change-password-success');
                var $formErrors = $('.js-form-error');

                var sendLostPassword = function() {
                    var password = $("#change-pass-password").val();
                    var passwordRepeat = $("#change-pass-password-repeat").val();
                    var key = $("#change-pass-key").val();

                    if (password.length < 5) {
                        $formErrors.addClass('js-hide');
                        $('.js-form-error-password_too_short').removeClass('js-hide');
                        return false;
                    }

                    if (password !== passwordRepeat) {
                        $formErrors.addClass('js-hide');
                        $('.js-form-error-same_password').removeClass('js-hide');
                        return false;
                    }

                    $loader.fadeIn();

                    $.ajax({
                        type: 'POST',
                        url: ajaxurl, // check the exact URL for your situation
                        dataType: 'JSON',
                        data: ({ action: 'member_change_password', password: password, key: key }),
                        success: function(data) {

                            $formErrors.addClass('js-hide');

                            if (data.error) {

                                if (data.error === 'fields_not_filled') {
                                    $('.js-form-error-fields_not_filled').removeClass('js-hide');
                                }

                                if (data.error === 'not_registered') {
                                    $('.js-form-error-not_registered').removeClass('js-hide');
                                }

                            }

                            if (data.success) {
                                $changePasswordForm.fadeOut('fast', function() {
                                    $changePasswordSuccess.fadeIn('fast').fadeIn('fast');
                                });
                            }

                            $loader.fadeOut();

                        },
                        error: function(errorThrown) {
                            console.log("Error");
                            console.log(errorThrown);
                            $loader.fadeOut();
                            return false;
                        }

                    });
                };

                $changePasswordForm.submit(function(e){
                    e.preventDefault();
                    sendLostPassword();
                });

            }
        },
        // About us page, note the change from about-us to about_us.
        'single_client': {
            init: function() {
                // JavaScript to be fired on the about us page

                var iamSelect = $('.js-iam-select');

                iamSelect.change(function() {
                    $val = iamSelect.val();
                    window.location.href = $val;
                });

            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired

            }
        },
        // About us page, note the change from about-us to about_us.
        'page_template_page_entreprise': {
            init: function() {
                // JavaScript to be fired on the about us page
                $( window ).load(function() {
                    if(window.location.hash) {
                        var hash = window.location.hash.substring(1);

                        $('html, body').animate({
                            scrollTop: $('div[data-scrollTo="' + hash + '"]').offset().top - 90
                        });
                    }
                });

            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired

            }
        },
        // About us page, note the change from about-us to about_us.
        'page_template_page_edc': {
            init: function() {
                // JavaScript to be fired on the about us page
                var page = 1;
                var $noResult = $('.no-results');
                var $loadmore = $('.js-loadmore-cs-div');
                var $listSC = $('.list-edc');
                var $loader = $('.js-loader');

                var searchSC = function() {
                    $loader.fadeIn();
                    var service = $("#search-service").val();
                    var client = $("#search-client").val();
                    page = 1;

                    $.ajax({
                        type: "POST",
                        url: ajaxurl, // check the exact URL for your situation
                        dataType: 'JSON',
                        data: ({ action: 'loadmore_sc', service: service, client: client, page: page, lang: currentLang }),
                        success: function(data) {

                            $listSC.hide().html(data.html).fadeIn();

                            if (data.showMore) {
                                // $loadmore.removeClass('js-hide');
                                $loadmore.fadeIn();
                            } else {
                                // $loadmore.addClass('js-hide');
                                $loadmore.fadeOut();
                            }

                            if (data.nbPost === 0) {
                                $noResult.fadeIn();
                            } else {
                                $noResult.fadeOut();
                            }

                            $(window).trigger('resize');
                            onResize('.equal-height');

                            $loader.fadeOut();
                        },
                        error: function(errorThrown) {
                            console.log("Error");
                            console.log(errorThrown);
                            $loader.fadeOut();
                            return false;
                        }

                    });
                };

                $('.js-search-cs').click(function(e){
                    e.preventDefault();
                    searchSC();
                });


                var loadmoreSC = function() {
                    $loader.fadeIn();
                    var service = $("#search-service").val();
                    var client = $("#search-client").val();
                    page++;

                    $.ajax({
                        type: "POST",
                        url: ajaxurl, // check the exact URL for your situation
                        dataType: 'JSON',
                        data: ({ action: 'loadmore_sc', service: service, client: client, page: page, lang: currentLang}),
                        success: function(data) {
                            $listSC.append(data.html);
                            if (data.showMore) {
                                // $loadmore.removeClass('js-hide');
                                $loadmore.fadeIn();
                            } else {
                                // $loadmore.addClass('js-hide');
                                $loadmore.fadeOut();
                            }

                            $(window).trigger('resize');
                            onResize('.equal-height');

                            $loader.fadeOut();
                        },
                        error: function(errorThrown) {
                            console.log("Error");
                            console.log(errorThrown);
                            $loader.fadeOut();
                            return false;
                        }

                    });
                };

                $('.js-loadmore-cs').click(function(e){
                    e.preventDefault();
                    loadmoreSC();
                });

            }
        },
        // About us page, note the change from about-us to about_us.
        'page_template_page_blog': {
            init: function() {
                // JavaScript to be fired on the about us page
                var page = 1;
                var $loader = $('.js-loader');
                var $loadmore = $('.js-loadmore-news-div');
                var $listA = $('.list-news');

                var loadmoreNews = function() {
                    $loader.fadeIn();
                    page++;

                    $.ajax({
                        type: "POST",
                        url: ajaxurl, // check the exact URL for your situation
                        dataType: 'JSON',
                        data: ({ action: 'loadmore_article', page: page, lang: currentLang}),
                        success: function(data) {
                            $listA.append(data.html);
                            if (data.showMore) {
                                $loadmore.fadeIn();
                            } else {
                                $loadmore.fadeOut();
                            }

                            $(window).trigger('resize');
                            onResize('.equal-height-2');

                            $loader.fadeOut();
                        },
                        error: function(errorThrown) {
                            console.log("Error");
                            console.log(errorThrown);
                            $loader.fadeOut();
                            return false;
                        }

                    });
                };

                $('.js-loadmore-news').click(function(e){
                    e.preventDefault();
                    loadmoreNews();
                });

            }
        },
        'page_template_page_references': {
            init: function() {
                // JavaScript to be fired on the about us page

                var $search = $('.js-documents-search');
                var $rows = $('.js-document-row');

                $search.change(function() {
                    $val = $search.val();

                    $rows.each(function(index, el) {
                        var $row = $(el);
                        if ($val === '0') {
                            $row.fadeIn();
                            return true;
                        }

                        if (!$row.hasClass($val)) {
                            $row.fadeOut();
                        } else {
                            $row.fadeIn();
                        }

                    });

                });

            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired

            }
        },
        'page_template_page_compte': {
            init: function() {
                // JavaScript to be fired on the about us page
                var $loader = $('.js-loader');
                var isProfilOpen = false;
                var $popupProfil = $('.js-popup-profil');
                var $formErrors = $('.js-form-error');
                var $saveProfilSuccess = $('.js-form-profil-success');
                var $savePasswordSuccess = $('.js-form-password-success');
                var $username = $('.username');

                var toggleProfilPopup = function(){
                    if (!isProfilOpen) {
                        $popupProfil.fadeIn();
                        isProfilOpen = true;
                    }else{
                        $popupProfil.fadeOut();
                        isProfilOpen = false;
                    }
                };


                $('.js-toggle-popup-profil').click(function(e){
                    e.preventDefault();
                    $formErrors.addClass('js-hide');
                    $saveProfilSuccess.hide();
                    toggleProfilPopup();
                });







                var saveProfil = function() {
                    $loader.fadeIn();
                    var firstName = $("#profil-first_name").val();
                    var lastName = $("#profil-last_name").val();
                    var emailNotification = $('#profil-email_notification').is(":checked") ? 1 : 0;
                    var id = $("#profil-id").val();
                    $saveProfilSuccess.fadeOut();

                    $.ajax({
                        type: 'POST',
                        url: ajaxurl, // check the exact URL for your situation
                        dataType: 'JSON',
                        data: ({ action: 'member_save_profil', first_name: firstName, last_name: lastName, member: id, email_notification: emailNotification}),
                        success: function(data) {
                            $formErrors.addClass('js-hide');

                            if (data.error) {

                                if (data.error === 'fields_not_filled') {
                                    $('.js-form-error-fields_not_filled').removeClass('js-hide');
                                }

                            } else {
                                $username.html(firstName + ' ' + lastName);
                                $saveProfilSuccess.fadeIn();
                            }

                            $loader.fadeOut();

                        },
                        error: function(errorThrown) {
                            console.log("Error");
                            console.log(errorThrown);
                            $loader.fadeOut();
                            return false;
                        }

                    });
                };

                $('#js-profil').submit(function(e){
                    e.preventDefault();
                    saveProfil();
                });







                var changePassword = function() {
                    $loader.fadeIn();
                    var currentPassword = $("#change-current-password").val();
                    var newPassword = $("#change-new-password").val();
                    var newPasswordRepeat = $("#change-new-password-repeat").val();
                    var id = $("#change-password-id").val();

                    $savePasswordSuccess.fadeOut();

                    $.ajax({
                        type: 'POST',
                        url: ajaxurl, // check the exact URL for your situation
                        dataType: 'JSON',
                        data: ({ action: 'member_save_profil_password', current_password: currentPassword, new_password: newPassword, new_password_repeat: newPasswordRepeat, member: id }),
                        success: function(data) {
                            $formErrors.addClass('js-hide');

                            if (data.error) {

                                if (data.error === 'fields_not_filled') {
                                    $('.js-form-error-fields_not_filled').removeClass('js-hide');
                                }

                                if (data.error === 'password_too_short') {
                                    $('.js-form-error-password_too_short').removeClass('js-hide');
                                }

                                if (data.error === 'same_password') {
                                    $('.js-form-error-same_password').removeClass('js-hide');
                                }

                                if (data.error === 'wrong_password') {
                                    $('.js-form-error-wrong_password').removeClass('js-hide');
                                }

                            } else {
                                $savePasswordSuccess.fadeIn();
                            }

                            $loader.fadeOut();

                        },
                        error: function(errorThrown) {
                            console.log("Error");
                            console.log(errorThrown);
                            $loader.fadeOut();
                            return false;
                        }

                    });
                };

                $('#js-change_password').submit(function(e){
                    e.preventDefault();
                    changePassword();
                });



            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired

            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    window.Utils = window.Utils || {};

    /**
     * Set equal height for all elements passed in parameters
     * @param {jQuery list} $col
     */
    Utils.setEqualHeight = function($col) {
        // Find max height
        var maxHeight = 0;
        $col.each(function() {
            var $this = $(this);
            $this.removeAttr('style'); // Remove previously set height for responsive behavior

            var $height = $this.innerHeight();

            if ($height > maxHeight) {
                maxHeight = $height;
            }
        });

        // Set height
        $col.each(function() {
            $(this).css('height', maxHeight);
        });
    };

    /**
     * Remove equal height for all elements passed in parameters
     * @param {jQuery list} $col
     */
    Utils.removeEqualHeight = function($col) {
        $col.each(function() {
            $(this).removeAttr('style');
        });
    };

    function onResize(equalBloc) {
        $equalHeightBloc = $(equalBloc);
        if ($(window).width() < 768) {
            if ($equalHeightBloc.length > 0) {
                Utils.removeEqualHeight($equalHeightBloc);
            }
        } else {
            if ($equalHeightBloc.length > 0) {
                Utils.setEqualHeight($equalHeightBloc);
            }
        }
    }

    $(window).on('load resize', function() {
        onResize('.bloc-icon-equal');
        onResize('.environment-item-1');
        onResize('.environment-item-2');
        onResize('.environment-item-3');
        onResize('.equal-col-num');
        onResize('.equal-col-team');
        onResize('.equal-col-recognition');
        onResize('.equal-height');
        onResize('.equal-height-2');
        onResize('.equal-height-edc');
    });

    /**
     * SELECT 2 - CUSTOM SELECT
     */
    $('select:not(.skip-me)').select2({
        minimumResultsForSearch: -1
    });

    /**
     * CLOSE POPUP
     */
     // click on close button
     $('.close-popup').click(function(){
        $(this).closest('.popup').fadeOut();
     });

    /**
     * OWL CAROUSEL - ENTREPRISE > PARTENAIRES
     */
    $("#owl-partners").owlCarousel({
        items: 3,
        responsive : {
            // breakpoint from 0 up
            0 : {
                items:1
            },
            // breakpoint from 480 up
            480 : {
                items:2
            },
            // breakpoint from 768 up
            768 : {
                items:3
            }
        },
        autoplay: true,
        loop:true,
        autoplayTimeout: 3000,
        autoplaySpeed: 800,
        autoplayHoverPause: true,
        nav: true,
        navSpeed: 800,
        dots: false
    });

    /**
     * OWL CAROUSEL - BLOC MEDIA
     */
    $("#owl-carousel-media").owlCarousel({
        nav: true,
        navSpeed: 800,
        items: 1,
        dots: false
    });

    /**
     * INLINE SVG
     */
    function inlineSVG(selector) {
        $(selector).each(function() {
            var $img = $(this),
                imgID = $img.attr('id'),
                imgClass = $img.attr('class'),
                imgURL = $img.attr('src');

            $.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                var $svg = $(data).find('svg');

                // Add old image's attributes to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }

                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
                if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
                }

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');

        });
    }

    inlineSVG('.js-inline-svg');

    /**
     * ANCHORS
     */
    $('.anchor').click(function(event) {
        event.preventDefault();
        var idSection = $(this).attr('href');
        var goToSection = $(idSection);
        var headerHeight = $('.header').height();
        $('html,body').animate({ scrollTop: goToSection.offset().top - headerHeight }, 600);
    });


    /**
     * TABLE EMPLOIS / STAGES
     */
    $('.career-cat').click(function() {
        var $this = $(this);
        var dataCat = $this.attr('data-cat');

        $('.career-cat').removeClass('active');
        $this.addClass('active');
        $('.table-wrapper').hide();
        $('.table-' + dataCat).fadeIn();

        return false;
    });

    /**
     * HEADER SEARCH
     */
    $('.btn-search').click(function() {
        var form = $('.form-search');
        var input = $('.input-search');
        // Open input
        if (!form.hasClass('active')) {
            form.addClass('active');
            return false;
        } else {
            if (input.val() === '') {
                form.removeClass('active');
                return false;
            }
        }
    });

    $('#js-upload-cv').on('change',function(){
         if($(this).val()){
             var fileInput = document.getElementById('js-upload-cv');
             var filename = fileInput.files[0].name;
             $(this).parent().find('.-is-attached').html(filename);
             $(this).parent().addClass('is-active')
         }else{
             $(this).parent().removeClass('is-active');
         }
     });
     $('#js-upload-lp').on('change',function(){
         if($(this).val()){
             var fileInput = document.getElementById('js-upload-lp');
             var filename = fileInput.files[0].name;
             $(this).parent().find('.-is-attached').html(filename);
             $(this).parent().addClass('is-active')
         }else{
             $(this).parent().removeClass('is-active');
         }
     });

    /**
     * MENU FIXE AU SCROLL
     */
     $(window).on('load resize', function() {
         var headerHeight = $('.header').height();
         $('body > .wrap').css({ 'padding-top': headerHeight });
     });

     $(window).scroll(function() {
        var windowScroll = $(window).scrollTop();
        var header = $('.header');
        var headerHeight = header.height();

        if (windowScroll > headerHeight) {
            header.addClass('smaller');
        }
        if (windowScroll < headerHeight) {
            header.removeClass('smaller');
        }
     });

    // $(window).scroll(function() {
    //     var windowScroll = $(window).scrollTop();
    //     var menu = $('.header-menu');
    //     var menuHeight = menu.height();
    //     var topbarHeight = $('.top-bar').height();
    //     var wrapperPage = $('body > .wrap');

    //     if (windowScroll > topbarHeight) {
    //         menu.addClass('fixed');
    //         wrapperPage.css({ 'padding-top': menuHeight });
    //     }

    //     if (windowScroll < topbarHeight) {
    //         menu.removeClass('fixed');
    //         wrapperPage.css({ 'padding-top': 0 });
    //     }
    // });

    /**
     * MENU MOBILE
     */
    $('.toggle-menu').click(function() {
        var menu = $('.col-menu');
        var activeMenu = $('.col-menu.active');

        if (!menu.hasClass('active')) {
            $('.header-menu').addClass('active');
            menu.addClass('active');
            menu.css({
                'max-height': $(window).height() * 0.8
            });
        } else {
            $('.header-menu').removeClass('active');
            menu.removeClass('active');
        }
    });

    /**
     * MENU PLUS MOBILE
     */
    $('.toggle-topbar').click(function() {
        var topbar = $('.top-bar');

        if (!topbar.hasClass('active')) {
            topbar.addClass('active');
        } else {
            topbar.removeClass('active');
        }
    });

    /**
     * SOCIAL SHARE
     */
    function SocialShare() {

        var self = this,

            titleFacebook = 'Partager sur Facebook',
            titleTwitter = 'Partager sur Twitter',
            titleLinkedIn = 'Partager sur LinkedIn',
            titleGooglePlus = 'Partager sur Google+',

            title = '',
            text = '',
            url = '',

            winHeight = 300,
            winWidth = 550,
            winTop = (screen.height / 2) - (winHeight / 2),
            winLeft = (screen.width / 2) - (winWidth / 2),

            windowParam = 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight,

            options = {};

        /**
         * Facebook share
         */
        function shareFacebook() {
            window.open('http://www.facebook.com/sharer/sharer.php?u=' +
                encodeURIComponent(url), titleFacebook, windowParam);
        }

        /**
         * Twitter share
         */
        function shareTwitter() {
            window.open('http://twitter.com/share?url=' +
                encodeURIComponent(url) + '&text=' +
                encodeURIComponent(text) + '&count=none/',
                titleTwitter, windowParam);
        }

        /**
         * LinkedIn share
         */
        function shareLinkedIn() {
            window.open('https://www.linkedin.com/cws/share?url=' +
                encodeURIComponent(url), titleLinkedIn, windowParam);
        }

        /**
         * Google+ share
         */
        function shareGoogle() {
            window.open('https://plus.google.com/share?url=' +
                encodeURIComponent(url), titleGooglePlus, windowParam);
        }

        /**
         * Public constructor
         * @param  {Object} opts Options
         */
        self.initialize = function(opts) {

            //extends options
            for (var i in opts) { options[i] = opts[i]; }

            if (options.titleFacebook) { titleFacebook = options.titleFacebook; }
            if (options.titleTwitter) { titleTwitter = options.titleTwitter; }
            if (options.titleLinkedIn) { titleLinkedIn = options.titleLinkedIn; }
            if (options.titleGooglePlus) { titleGooglePlus = options.titleGooglePlus; }

            url = window.location.href;
            title = $('title').text();
            text = $('[property="og:description"]').attr('content') || '';

            $('body').on('click', options.button, function(e) {
                var $this = $(this);

                // Inside list of items
                if ($this.attr('data-url')) {
                    url = $this.attr('data-url');
                }
                if ($this.attr('data-title')) {
                    title = $this.attr('data-title');
                }
                if ($this.attr('data-text')) {
                    text = $this.attr('data-text');
                }

                // Single item
                if ($this.attr('data-type') === 'facebook') {
                    shareFacebook();
                } else if ($this.attr('data-type') === 'twitter') {
                    shareTwitter();
                } else if ($this.attr('data-type') === 'linkedin') {
                    shareLinkedIn();
                } else if ($this.attr('data-type') === 'google') {
                    shareGoogle();
                }
            });

        };

        self.initialize.apply(self, arguments);
        return self;
    }

    new SocialShare({
        'button': '.js-social-share'
    });

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
